import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import { Category, OrderBy } from "./-constant";

export const SearchSchema = z.object({
  page: z.number().min(1).default(1),
  orderDirection: z
    .nativeEnum(OrderDirection)
    .optional()
    .default(OrderDirection.ASC),
  orderBy: z.nativeEnum(OrderBy).default(OrderBy.ACCEPTED_DATE), //TODO:受注日に対応できたら変更
  category: z.nativeEnum(Category).default(Category.UNTOUCHED),
  freeText: z.string().optional(),
  sentAtFrom: z.string().optional(),
  sentAtTo: z.string().optional(),
  acceptedAtFrom: z.string().optional(),
  acceptedAtTo: z.string().optional(),
  canceledAtFrom: z.string().optional(),
  canceledAtTo: z.string().optional(),
  customerOrgId: z.string().optional(),
  pageSize: z.number().int().positive().default(100),
  pageIndex: z.number().int().min(0).default(0),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
